import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useUI } from '../context/UIContext';

// Layout Components
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

// Section Components
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Qualifications from '../components/sections/Qualifications';
import Projects from '../components/sections/Projects';
import Reviews from '../components/sections/Reviews';
import Contact from '../components/sections/Contact';
import ServiceArea from '../components/sections/ServiceArea';

const Home = () => {
  const { setActiveSection } = useUI();

  // Update active section based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setActiveSection]);

  return (
    <>
      <Helmet>
        <title>J&C Renovations | General Contractor | Waddy, Kentucky</title>
        <meta
          name="description"
          content="Trusted general contractor in Waddy, Kentucky. Licensed, and fully insured for commercial and residential construction. Serving Spencer County and central Kentucky with reliable, professional service."
        />
        <link rel="canonical" href="https://jandcrenovations.com" />
      </Helmet>

      <Header />
      
      <main>
        <Hero />
        <About />
        <Services />
        <Qualifications />
        <Projects />
        <Reviews />
        <ServiceArea />
        <Contact />
      </main>
      
      <Footer />
    </>
  );
};

export default Home;
